import styled from 'styled-components';
import {
  DialogAlert,
  ButtonTertiary,
  spacer8,
  spacer12,
  spacer16,
  white,
  screenSmMin,
} from '@spotify-internal/encore-web';

export const StyledContainer = styled.div<{ isShow: boolean }>`
  width: 100%;
  position: fixed;
  top: 100%;
  right: 0;
  box-sizing: border-box;
  padding: 0 ${spacer16} ${spacer8};
  z-index: 1030;
  transition: transform ease-in-out 400ms, opacity ease-in-out 300ms;
  opacity: ${({ isShow }) => (isShow ? 1 : 0)};
  transform: ${({ isShow }) => (isShow ? 'translateY(-100%) scale(1)' : 'translateY(0) scale(0.7)')};

  @media (min-width: ${screenSmMin}) {
    width: 360px;
  }
`;

export const StyledDialog = styled.div`
  position: relative;
`;

export const StyledDialogHeader = styled.div`
  padding-right: ${spacer16};
`;

export const StyledCloseButton = styled(ButtonTertiary)`
  position: absolute;
  top: 0;
  right: 0;
  margin: ${spacer8} ${spacer12};
  z-index: 1050;
  color: ${white};
`;

export const StyledDialogAlert = styled(DialogAlert)`
  min-width: 100%;
  width: 100%;
`;

export const StyledActions = styled.div`
  display: flex;
  flex-direction: row !important;
  justify-content: space-around !important;
  width: 100%;

  @media (min-width: ${screenSmMin}) {
    justify-content: flex-end !important;
  }
`;
